module.exports = __webpack_public_path__ + "a17d279f/img/comment-question-icon.7dd26e04.svg";